import { useMemo, useState } from "preact/hooks";
import jwtDecode from "jwt-decode";

function useAccessToken() {
  return useMemo(() => {
    const decoded = jwtDecode(window.localStorage.getItem("accessToken"));

    return decoded;
  }, []);
}

export function useUserInitial() {
  const decoded = useAccessToken();
  return {
    userInitial: (decoded.user.lastname || "x")[0],
  };
}

export function useUserInfo() {
  const decoded = useAccessToken();

  return decoded.user;
}
